// filepath: /c:/Users/joanr/Desktop/pagina web de blog para adsense/mi-app/src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import BlogList from './blog/BlogList';
import BlogPost from './blog/BlogPost';
import NewPost from './blog/NewPost';
import Header from './components/Header';

const App = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/new-post" element={<NewPost />} />
      </Routes>
    </Router>
  );
};

export default App;